/**
 * ROC 7
 * Copyright 2016 ROC Commerce
 * 
 * Any modifications required of core files should be handled in supplemental files 
 * or duplicates of said core files. This is to assist in upgrade paths.
 */


define('modules/User/UserB2B.Service',[
    'jquery',
    'global/all'
], function ($, Roc) {
    'use strict';

    var apiUrl = window.RocConfig.api.baseRocApiUrl;

    /**
     * Add sub user account to master organization
     * @param {} request 
     * @returns {} 
     */
    function addSubUser(request) {
        return $.ajax({
            url: apiUrl + '/api/b2b/organization/addSubUser',
            type: 'POST',
            contentType: 'application/json',
            dataType: 'json',
            data: JSON.stringify(request),
            complete: function (xhr) {
                Roc.Logger.info('UserB2B -> addSubUser');
                Roc.Logger.info(xhr);
            }
        });
    }

    /**
     * Edit sub user permissions
     * @param {} request 
     * @returns {} 
     */
    function editSubUser(request) {
        return $.ajax({
            url: apiUrl + '/api/b2b/organization/editUser',
            type: 'POST',
            contentType: 'application/json',
            dataType: 'json',
            data: JSON.stringify(request),
            complete: function (xhr) {
                Roc.Logger.info('UserB2B -> editSubUser');
                Roc.Logger.info(xhr);
            }
        });
    }

    /**
     * Remove/detach sub user from organization
     * @param {} userId 
     * @returns {} 
     */
    function removeUser(userId) {
        return $.ajax({
            url: apiUrl + '/api/b2b/organization/user/' + userId,
            type: 'DELETE',
            dataType: 'json',
            contentType: 'application/json',
            complete: function (xhr) {
                Roc.Logger.info('UserB2B -> removeUser');
                Roc.Logger.info(xhr);
            }
        });
    }


    var UserB2BService = {
        addSubUser: addSubUser,
        editSubUser: editSubUser,
        removeUser: removeUser
    };

    Roc.Logger.debug('UserB2B.Service.js Loaded:', UserB2BService);

    return UserB2BService;
});
